export default [
  {
    name: "SsoCommercialCallback",
    path: "/sso/callback",
    component: () => import("@/views/sso/CommercialCallback"),
    meta: {
      // Landing point for the Commercial -> Residential SSO handoff. Must be
      // reachable with no session at all, so it skips auth/maintenance
      // middleware the same way the public Landing page does.
      middleware_excemption: true
    }
  },
  {
    name: "SsoCommercialBridge",
    path: "/sso/bridge",
    component: () => import("@/views/sso/CommercialBridge"),
    meta: {
      // Landing point for the "Login with Commercial SSO" button on
      // commercial's own login page. Must run before redirectIfAuthorized
      // would otherwise bounce an authenticated visitor off of a route named
      // like a login page, and must also be reachable with no session at all.
      middleware_excemption: true
    }
  }
];
